import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import PropTypes from 'prop-types';

InputField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  label2: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.string,
};

function InputField(props) {
  const { value, id, label = null, label2 = null, defaultValue = null, onChange = null, disabled = false, type = 'text', hint, placeholder, error, inputProps } = props;
  const [inputValue, setInputValue] = useState(defaultValue ?? null);

  useEffect(() => {
    setInputValue(value);
  });

  function handleInputChange(e) {
    setInputValue(e.target.value);
    if (onChange) {
      onChange(e);
    }
  }

  return (
    <>
      <span>
        {label}
        <i>
          <small> {label2}</small>
        </i>
      </span>
      <TextField
        type={type}
        id={id}
        key={id}
        value={inputValue}
        disabled={disabled}
        helperText={hint}
        onChange={handleInputChange}
        variant="outlined"
        size="small"
        fullWidth
        placeholder={placeholder}
        error={error}
        slotProps={{
          htmlInput: inputProps,
        }}
      />
    </>
  );
}

export default InputField;
